import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * hallmark critique · RouteHighlightLayer
 * tokens locked from docs/design.md §1 (map colours: op-brand + clay accent
 *   for the "your bus" halo) + §10 (marker styles)
 * states covered: idle (no route) · active (route + stops rendered)
 * mobile verified: 320 / 375 / 414 / 768
 * no fake chrome · no shadows · single clay accent held by "your bus" halo
 *
 * Renders a Leaflet Polyline through every stop of a selected route, plus
 * small circle markers at each stop, plus (optional) a clay-ember halo on
 * the specific "your bus" position and a cool-ash halo on its bunching
 * partner. Mounted inside <MapContainer/> as a sibling of VehicleLayer.
 *
 * Phase 13e — click-a-bus → highlight this route.
 */
import { CircleMarker, Polyline, Tooltip } from "react-leaflet";
import { colors } from "../../lib/tokens";
export function RouteHighlightLayer({ route, focusPosition, bunchingWithPosition, }) {
    if (!route || !route.stops || route.stops.length < 2)
        return null;
    const positions = route.stops.map((s) => [s.lat, s.lon]);
    return (_jsxs(_Fragment, { children: [_jsx(Polyline, { positions: positions, pathOptions: {
                    color: colors.pureWhite,
                    weight: 8,
                    opacity: 0.6,
                    lineCap: "round",
                    lineJoin: "round",
                } }), _jsx(Polyline, { positions: positions, pathOptions: {
                    color: route.color,
                    weight: 4,
                    opacity: 0.9,
                    lineCap: "round",
                    lineJoin: "round",
                } }), route.stops.map((s, i) => {
                const isTerminus = i === 0 || i === route.stops.length - 1;
                return (_jsx(CircleMarker, { center: [s.lat, s.lon], radius: isTerminus ? 7 : 4, pathOptions: {
                        color: route.color,
                        fillColor: colors.pureWhite,
                        fillOpacity: 1,
                        weight: isTerminus ? 3 : 2,
                    }, children: _jsx(Tooltip, { direction: i === 0 ? "right" : i === route.stops.length - 1 ? "left" : "top", offset: [0, -6], opacity: 0.95, permanent: isTerminus, children: _jsx("span", { style: { fontFamily: "var(--font-display)", fontSize: 11 }, children: isTerminus ? _jsx("strong", { children: s.stop_name }) : s.stop_name }) }) }, s.stop_id));
            }), focusPosition && (_jsx(CircleMarker, { center: [focusPosition.lat, focusPosition.lng], radius: 14, pathOptions: {
                    color: colors.clayEmber,
                    fillColor: colors.clayEmber,
                    fillOpacity: 0.15,
                    weight: 3,
                } })), bunchingWithPosition && (_jsx(CircleMarker, { center: [bunchingWithPosition.lat, bunchingWithPosition.lng], radius: 14, pathOptions: {
                    color: colors.coolAsh,
                    fillColor: colors.coolAsh,
                    fillOpacity: 0.15,
                    weight: 3,
                    dashArray: "4 4",
                } }))] }));
}
